import React from 'react'
import { CreditCardInputElement } from '/src/components/commerce/form'

export const PaymentCyberSourcePaneForm = ({ control, register }) => {
  return (
    <div className="payment-credit-card-pane">
      <CreditCardInputElement control={control} register={register} />
    </div>
  )
}

export default PaymentCyberSourcePaneForm
